export default __webpack_public_path__ + "static/media/Reds.0503af09.png";